export class AdjustmentValidation {
    public constructor(init?: Partial<AdjustmentValidation>) {
      Object.assign(this, init);
    }
        isInvalid: boolean = false;
        netAmountMessage: string;
        grossAmountMessage: string;
        adjustmentReasonMessage: string;
        commentMessage: string;
   }